import { ChecklistItem } from '@app/app/_components/ChecklistItem/ChecklistItem';
import { ProductDataRider } from '@app/domain/model/eshop/transport/ProductDataRider';
import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';

export function generateRiderDetails(rider: ProductDataRider, t: ReturnType<typeof useTranslations>): ReactNode {
    const effectiveCode = rider.typeCode ?? rider.premiums.risks[0]?.riskCode;

    if (!effectiveCode) {
        return <></>;
    }

    const riderDetails = t.raw(`eshop.transport.riderDetails.${effectiveCode}`);

    if (!riderDetails) {
        return <></>;
    }

    const { description, additionalInfo, ...beneficiaryList } = riderDetails;

    const benefits = Object.entries(beneficiaryList)
        .filter(([key]) => key.startsWith('ben'))
        .sort(([a], [b]) => a.localeCompare(b, undefined, { numeric: true }))
        .map(([, value]) => String(value));

    return (
        <div className="text-gray-700 flex flex-col gap-3">
            <div>{description}</div>

            {benefits.length > 0 && (
                <div className="flex flex-col gap-2">
                    {benefits.map((benefit: string, idx: number) => (
                        <ChecklistItem key={`${effectiveCode}-ben${idx + 1}`}>{benefit}</ChecklistItem>
                    ))}
                </div>
            )}

            {additionalInfo && <div>{additionalInfo}</div>}
        </div>
    );
}
